import type { PlatformRequestConfig } from 'Models/uiConfig/requestConfig';

const requestConfig: PlatformRequestConfig = {};

export default requestConfig;
